(function() {
  function getTexts() {
    var isEn = window.location.pathname.indexOf('/en') === 0;
    if (isEn) {
      return {
        agree: 'I agree to the ',
        terms: 'Terms of Service',
        and: ' and ',
        privacy: 'Privacy Policy',
        end: '.'
      };
    }
    return {
      agree: 'Es piekrītu ',
      terms: 'Lietošanas noteikumiem',
      and: ' un ',
      privacy: 'Privātuma politikai',
      end: '.'
    };
  }

  function initCartTerms() {
    var checkoutBtn = document.querySelector('#checkout');
    if (!checkoutBtn) return;
    if (document.querySelector('.cart-terms-wrap')) {
      checkoutBtn.disabled = !document.getElementById('cart-terms').checked;
      return;
    }

    var style = document.createElement('style');
    style.innerHTML = `
      .cart-terms-wrap { padding: 12px 0 0; }
      .cart-terms-label { display: flex; align-items: flex-start; gap: 10px; cursor: pointer; font-size: 15px; color: black; line-height: 1.5; }
      .cart-terms-checkbox { width: 16px; height: 16px; min-width: 16px; border: 1px solid rgba(118,58,68,0.4); border-radius: 0; appearance: none; -webkit-appearance: none; cursor: pointer; margin-top: 2px; background: #ffffff; transition: background 0.2s ease, border-color 0.2s ease; }
      .cart-terms-checkbox:checked { background: #763a44; border-color: #763a44; background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 7l4 4 6-7' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: center; background-size: 10px; }
      .cart-terms-link { color: #763a44; text-decoration: underline; }
      .cart__checkout-button:disabled { opacity: 0.4; cursor: not-allowed; pointer-events: none; }
    `;
    document.head.appendChild(style);

    var t = getTexts();

    var wrap = document.createElement('div');
    wrap.className = 'cart-terms-wrap';
    wrap.innerHTML = `
      <label class="cart-terms-label">
        <input type="checkbox" class="cart-terms-checkbox" id="cart-terms">
        <span>${t.agree}<a class="cart-terms-link" href="/policies/terms-of-service" target="_blank">${t.terms}</a>${t.and}<a class="cart-terms-link" href="/policies/privacy-policy" target="_blank">${t.privacy}</a>${t.end}</span>
      </label>
    `;

    checkoutBtn.parentNode.insertBefore(wrap, checkoutBtn);
    checkoutBtn.disabled = true;

    document.getElementById('cart-terms').addEventListener('change', function() {
      checkoutBtn.disabled = !this.checked;
    });
  }

  var observer = new MutationObserver(function() {
    setTimeout(initCartTerms, 400);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', initCartTerms);
})();